import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import { BaseDialog } from '../../Dialog-types/base-dialog';
import { ButtonInfo } from 'src/app/common/UI-Components/helperClasses/value-and-display.class';
import { ServerApi } from 'src/app/services/api.services/server.api';
import { ISphereXgConfig } from 'src/app/common/Models/UI/point-cloud.interface';
import { PointCloudSvc } from 'src/app/services/api.services/point-cloud.service';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/Store/app.state/app.state';
import { InputsBindingsModel } from 'src/app/common/Models/Dialog/inputs-binding.model';
import { ICompanyInfo } from 'src/app/common/Models/UI/company-info.interface';
import { DialogService, DialogType } from 'src/app/services/dialogs.service';
import { DialogRef } from '../../Dialog-types/dialog-ref';
import { NotificationDialogComponent } from '../notification-dialog/notification-dialog.component';
import { map } from 'rxjs/operators';
import { EditorMode } from '../dialog.helper';
import { DialogModel } from 'src/app/common/Models/Dialog/dialog.model';
import { MessagesBank, StatusService } from 'src/app/services/status.service';
import { AddEditPointCloudConfDialogComponent } from '../add-edit-point-cloud-conf-dialog/add-edit-point-cloud-conf-dialog.component';
import { SphereXGApiService } from 'src/app/services/api.services/sphereXG.api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { cloneDeep } from 'lodash';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { TooltipDirective } from '../../../../Directives/tooltip.directive';
import { NgClass, AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'perfect-scrollbar-angular';
@Component({
    selector: 'ins-point-cloud-conf-dialog',
    templateUrl: './point-cloud-conf-dialog.component.html',
    styleUrls: ['./point-cloud-conf-dialog.component.scss', './../shared-dialogs-ui.scss',
        './../../../UI-Components/shared-UI-components.scss', './../../../../Viewer/content.container/side-bar.container/subMenus/submenus-shared-design.scss'],
    imports: [MatIcon, TooltipDirective, FormsModule, PerfectScrollbarModule, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, NgClass, AsyncPipe]
})
export class PointCloudConfDialogComponent extends BaseDialog implements OnInit {
  companyInfo$: Observable<ICompanyInfo>;
  public companyInfo: ICompanyInfo;
  public buttonsInfo: ButtonInfo[] = [];

  public confColumns: string[] = ['select', 'name', 'domainHost', 'subject', 'audience', 'issuer'];
  public confDataSource: MatTableDataSource<any>;
  public showLoading: boolean = false;
  public noData;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public selectedRowIndex = -1;
  public selectedConf: ISphereXgConfig;
  public pointCloudConfs: ISphereXgConfig[] = [];

  public filteredDataCount: number = 0;
  public searchStr: string = '';
  public pointCloudAuthPending: boolean = false;

  constructor(public injector: Injector, private readonly pointCloudSvc: PointCloudSvc, private readonly sphereXGApiService: SphereXGApiService,
    public dialogService: DialogService, private readonly statusBar: StatusService, private readonly serverApi: ServerApi, private store: Store) {
    super(injector);
    this.companyInfo$ = this.store.select(AppState.getCompanyInfo);
    this.buttonsInfo.push(
      new ButtonInfo('cancel', 'Close'),
    );
  }

  public ngOnInit(): void {
    const pointCloudConfs = this.pointCloudSvc.getAllPointCloudConfs();
    this.pointCloudConfs = cloneDeep(pointCloudConfs);
    this.loadDataInGrid();
  }

  public defineDialogModel(): void {}

  onChanges(): void {}

  public loadDataInGrid(): void {
    this.confDataSource = new MatTableDataSource(this.pointCloudConfs);
    this.confDataSource.sort = this.sort;
    this.noData = this.confDataSource.connect().pipe(map(data => data.length === 0));
    this.confDataSource.filterPredicate = function(data, filter: string): boolean {
      return data.name.toLowerCase().includes(filter);
    };
  }

  public onSortChange(event: any): void {
    this.onRowUnselect();
  }

  public onRowUnselect() {
    this.selectedConf = null;
    this.selectedRowIndex = -1;
  }

  public onRowSelect(conf: ISphereXgConfig, index: number) {
    this.selectedRowIndex = index;
    this.selectedConf = conf;
  }

  private removeServiceAccountConfig(): void {
    this.statusBar.addNewStatus(MessagesBank.DELETING_POINTCLOUD_CONFIGURATION);
    this.sphereXGApiService.removeServiceAccountConfig(this.selectedConf.id).subscribe({
      next: (sphereXgSaConfig: ISphereXgConfig) => {
        const index: number = this.pointCloudConfs.findIndex((conf: ISphereXgConfig) => conf.id === this.selectedConf.id);
        if (index !== -1) {
          this.pointCloudConfs.splice(index, 1);
        }
        this.sphereXGApiService.pointCloudConfsDeleted(this.selectedConf, false);
        this.loadDataInGrid();
        this.onRowUnselect();
        this.statusBar.removeStatus(MessagesBank.DELETING_POINTCLOUD_CONFIGURATION);
      },
      error: (error: HttpErrorResponse) => {
        this.statusBar.removeStatus(MessagesBank.DELETING_POINTCLOUD_CONFIGURATION);
      }
    });
  }

  public addConfiguration() {
    let inputsBinding: InputsBindingsModel;
    inputsBinding = new Map<string, any>([
      [ 'dialogMode', EditorMode.NEW]
    ]);

    const dialog: DialogRef = this.dialogService.createDialog(AddEditPointCloudConfDialogComponent, DialogType.Modal, inputsBinding, null, 400);
    dialog.onClose$().subscribe(async (model: DialogModel) => {
      if (model.userAction === 'ok') {
        const sphereXgSaConfig: ISphereXgConfig = {
          id: model.getData('confId'),
          name: model.getData('name'),
          domainHost: model.getData('domainHost'),
          subject: model.getData('subject'),
          audience: model.getData('audience'),
          issuer: model.getData('issuer'),
          publicKey: btoa(model.getData('publicKey')),
          privateKey: btoa(model.getData('privateKey'))
        }
        this.pointCloudConfs.push(sphereXgSaConfig);
        this.loadDataInGrid();
        this.sphereXGApiService.pointCloudConfsCreated(sphereXgSaConfig, false);
      }
    });
  }

  public editConfiguration() {
    const sphereXgSaConfig= this.selectedConf
    let inputsBinding: InputsBindingsModel;
    inputsBinding = new Map<string, any>([
      [ 'confId', sphereXgSaConfig.id],
      [ 'name', sphereXgSaConfig.name],
      [ 'domainHost', sphereXgSaConfig.domainHost],
      [ 'subject', sphereXgSaConfig.subject],
      [ 'audience', sphereXgSaConfig.audience],
      [ 'issuer', sphereXgSaConfig.issuer],
      [ 'publicKey', atob(sphereXgSaConfig.publicKey)],
      [ 'privateKey', atob(sphereXgSaConfig.privateKey)],
      [ 'dialogMode', EditorMode.EDIT]
    ]);

    const dialog: DialogRef = this.dialogService.createDialog(AddEditPointCloudConfDialogComponent, DialogType.Modal, inputsBinding, null, 400);
    dialog.onClose$().subscribe(async (model: DialogModel) => {
      if (model.userAction === 'ok') {
        const updatedConfig: ISphereXgConfig = {
          id: sphereXgSaConfig.id,
          name: model.getData('name'),
          domainHost: model.getData('domainHost'),
          subject: model.getData('subject'),
          audience: model.getData('audience'),
          issuer: model.getData('issuer'),
          publicKey: btoa(model.getData('publicKey')),
          privateKey: btoa(model.getData('privateKey'))
        }
        const index: number = this.pointCloudConfs.findIndex((conf: ISphereXgConfig) => conf.id === updatedConfig.id);
        if (index !== -1) {
          this.pointCloudConfs[index] = updatedConfig;
        }
        this.selectedConf = updatedConfig;
        this.loadDataInGrid();
        this.sphereXGApiService.pointCloudConfsUpdated(updatedConfig, false);
      }
    });
  }

  public onRowClicked(conf: ISphereXgConfig, index: number, e: MouseEvent): void {
    if ( e.target['classList'].contains('mat-column-select') ) {
      if(this.selectedRowIndex != -1 && this.selectedRowIndex == index) {
        this.onRowUnselect();
      } else {
        this.onRowSelect(conf, index);
      }
    }
  }

  public deleteConfiguration() {
    if (this.selectedConf.id) {
      const inputsBinding: InputsBindingsModel = new Map([
        [ 'type', 'warning'],
        [ 'title', `Delete "${this.selectedConf.name}" Configuration` ],
        [ 'message', `Deleting configuration "${this.selectedConf.name}" will remove it from assigned sites. Are you sure you want to continue?`]
      ]);
      const dialog: DialogRef = this.dialogService.createNotificationDialog(inputsBinding);
      const dialogComp: NotificationDialogComponent = (dialog.instance as NotificationDialogComponent);
      dialogComp.buttonsInfo = [
        new ButtonInfo('cancel', 'Cancel'),
        new ButtonInfo('yes', 'Yes'),
      ];
      dialog.onClose$().subscribe((data) => {
        if (data.userAction === 'yes') {
          this.removeServiceAccountConfig();
        }
      });
    }
  }

  public isConfRowDisabled(conf: ISphereXgConfig): boolean {
    return false;
  }


  public getToolTipConf(element: any, label: string): any {
    let toolTipConf = {text: '', position: { H: 'hLeft', V:'vBottom' }, type: 'info'};
    if ( element.offsetWidth < element.scrollWidth )  {
      toolTipConf.text = label;
    }
    return toolTipConf;
  }

  public clearSearchStr(): void {
    this.searchStr = '';
    this.searchStrChanged('');
  }

  public searchStrChanged(filterValue: string): void {
    this.confDataSource.filter = filterValue.trim().toLowerCase();
    this.filteredDataCount = this.confDataSource.filteredData.length;
  }

  public async testPointCloudConnection(): Promise<void> {
    await this.sphereXGApiService.testPointCloudConnection(this.selectedConf);
    this.statusBar.removeStatus(MessagesBank.POINT_CLOUD_CHECK_CONNECTION_INPROGRESS);
  }

  public updateDialogValidity(valid: boolean): void {
    this.isDialogValid = valid;
  }

  public closeDialog(param: any): void {
    this.close(param);
  }
}